'use client';

import MetricLineChart from '../MetricLineChart';
import MetricBarChart from '../MetricBarChart';

// Sample data: Cycle time percentiles over time
const percentileData = [
  { name: 'Sprint 1', P50: 3.2, P75: 5.1, P95: 9.8 },
  { name: 'Sprint 2', P50: 2.9, P75: 4.7, P95: 8.9 },
  { name: 'Sprint 3', P50: 2.5, P75: 4.2, P95: 7.8 },
  { name: 'Sprint 4', P50: 2.3, P75: 3.8, P95: 6.9 },
  { name: 'Sprint 5', P50: 2.0, P75: 3.5, P95: 6.2 },
  { name: 'Sprint 6', P50: 1.8, P75: 3.2, P95: 5.5 },
];

// Sample data: Time breakdown by stage
const stageBreakdownData = [
  { name: 'Development', hours: 28.8, percentage: 35 },
  { name: 'Code Review', hours: 36.3, percentage: 44 },
  { name: 'Review Changes', hours: 7.4, percentage: 9 },
  { name: 'Testing', hours: 9.9, percentage: 12 },
];

// Sample data: Distribution histogram
const distributionData = [
  { name: '0-1d', count: 12 },
  { name: '1-2d', count: 25 },
  { name: '2-3d', count: 32 },
  { name: '3-5d', count: 18 },
  { name: '5-7d', count: 8 },
  { name: '7-10d', count: 3 },
  { name: '10d+', count: 2 },
];

export function CycleTimePercentilesChart() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">📊 Cycle Time Percentiles Over Time</h3>
      <MetricLineChart
        data={percentileData}
        lines={[
          { dataKey: 'P50', name: 'P50 (Median)', color: '#6FCF97' },
          { dataKey: 'P75', name: 'P75', color: '#4A90E2' },
          { dataKey: 'P95', name: 'P95', color: '#E89841' },
        ]}
        xAxisLabel="Sprint"
        yAxisLabel="Cycle Time (days)"
        targetLine={3}
        height={350}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Sample data showing consistent improvement across all percentiles. Median cycle time improved
        from 3.2 days to 1.8 days. Target line shows Elite threshold (&lt; 3 days).
      </p>
    </div>
  );
}

export function CycleTimeStageBreakdown() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">🔍 Bottleneck Analysis</h3>
      <MetricBarChart
        data={stageBreakdownData}
        bars={[
          { dataKey: 'hours', name: 'Time (hours)', color: '#E89841' },
        ]}
        xAxisLabel="Stage"
        yAxisLabel="Average Time (hours)"
        height={350}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Code Review is the primary bottleneck at 36.3 hours (44% of total cycle time).
        Focus optimization efforts here for maximum impact. Review SLA enforcement and PR size
        could help reduce this significantly.
      </p>
    </div>
  );
}

export function CycleTimeDistribution() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">📈 Cycle Time Distribution</h3>
      <MetricBarChart
        data={distributionData}
        bars={[
          { dataKey: 'count', name: 'Number of Tasks', color: '#E89841' },
        ]}
        xAxisLabel="Cycle Time Bucket"
        yAxisLabel="Count"
        height={300}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Most tasks complete in 2-3 days (mode). However, 13% of tasks take longer than 5 days.
        Investigate these outliers to identify blocking patterns or dependencies.
      </p>
    </div>
  );
}
